import { render, staticRenderFns } from "./BeerList.vue?vue&type=template&id=3c624e1d&scoped=true&"
import script from "./BeerList.vue?vue&type=script&lang=js&"
export * from "./BeerList.vue?vue&type=script&lang=js&"
import style0 from "./BeerList.vue?vue&type=style&index=0&id=3c624e1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c624e1d",
  null
  
)

export default component.exports